import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/nas-img.png';
import Img1 from '../../../assets/images/itm-5.png';
import Img2 from '../../../assets/images/itm-10.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-8.png';

const introSectionData3: IntroSectionData = {
  sectionTitle: "Bénéfices",
  sectionSubtitle: "En matière de cloud privé.",
  tabsData: [
    {
      id: 0,
      title: "Expertise",
      heading: "Maîtrise de la technologie",
      text: "Nous maîtrisons parfaitement les environnements de virtualisation légère et de conteneurisation sur les plateformes NAS. Nous configurons et optimisons ces environnements pour déployer et isoler vos applications.",
    },
    {
      id: 1,
      title: "Sécurité",
      heading: "Sécurisation de l'environnements",
      text: "Nous sommes experts en sécurisation des systèmes NAS, notre savoir faire s'étend au-delà bien des configurations de base. Nous implémentons des mesures de protection avancées pour vos cloud privés.",
    },
    {
      id: 2,
      title: "Déploiement",
      heading: "Déploiement et configuration",
      text: "Nous intégrons dans nos offres le déploiement et la configuration des principales suites collaboratives sur NAS pour vous offrir un environnement performant, sécurisé et aligné avec vos processus métiers.",
    },
    {
      id: 3,
      title: "Sauvegarde",
      heading: "Stratégies de sauvegarde et de reprise",
      text: "Nous savons concevoir et mettre en œuvre des stratégies de sauvegarde robustes adaptées aux environnements NAS. Nous définissons et planifions les procédures de restauration pour garantir une reprise rapide de votre activité en cas d'incident.",
    },
  ],
  fixedImageSrc: Img0,
  fixedImageAlt: "IT Monkeys Cloud Cyber",
};

export default introSectionData3;